import { fork, put, call, select, all } from 'redux-saga/effects';
import { selectAuthToken } from 'containers/App/selectors';
import { setModal } from "containers/RootModal/actions";
import { LAPSED_MODAL } from "./containers/RootModal/constants";

export function* apiSaga(fn, args, successAction, failureActions) {
  try {
    const response = yield call(fn, ...args);
    yield put(successAction(response));
  } catch(error){

    if (failureActions.length > 1 ) {
      let actions = failureActions.map(failureAction => put(failureAction(error)));
      yield all(actions);
    } else {
      if (error.message === 'Lapsed') {
        yield put(setModal({ modalType: LAPSED_MODAL }));
      } else {
        yield put(failureActions(error));
      }
    }
  }
}

export function* authedApiSaga(fn, args, successAction, failureAction) {
  const token = yield select(selectAuthToken());
  yield* apiSaga(fn, [token, ...args], successAction, failureAction);
}

// Collect Sagas and fork from containers
import appSaga from 'containers/App/sagas';
import signInSaga from 'containers/SignInPage/sagas';
import signUpSaga from 'containers/SelfSignUp/sagas';
import forgotPasswordSaga from 'containers/ForgotPasswordPage/sagas';
import channelsSaga from 'containers/ChannelsPage/sagas';
import accountSaga from 'containers/AccountPage/sagas';
import niceChoiceSaga from 'containers/NiceChoice/sagas';
import termsSaga from 'containers/TermsPage/sagas';
import leadSaga from 'containers/LeadsPage/sagas';
import accountVerificationSaga from 'containers/ConfirmEmailPage/sagas';
export default function* root() {
  yield all([
    fork(appSaga),
    fork(signInSaga),
    fork(signUpSaga),
    fork(channelsSaga),
    fork(forgotPasswordSaga),
    fork(accountSaga),
    fork(niceChoiceSaga),
    fork(termsSaga),
    fork(leadSaga),
    fork(accountVerificationSaga),
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas.js